import React, { useState, useEffect, useContext } from "react";
import "../ContentPages/style.css";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import FieldError from "../FieldError";
import AgeWarningModal from "../Popups/AgeWarningModal"; // import your modal
import { redirectToRealMe } from "../../Services/apiService"; // import the redirect function
import { AppContext } from "../../contexts/AppContext";
import {
  initiateApplication,
  updateApplication,
  getApplication,
  verifyArs,
} from "../../Services/applicationService"; // import the save function
import Loader from "../Loader/Loader";
import { toTitleCase } from "../../Utils/stringHandler.tsx"; // Assuming you have a utility function for title case
import { calculateAge, getCountryByLabel } from "../../Services/localStorage.tsx";
import { getValueFromLabel } from "../../Services/localStorage.tsx";
import FloatingTextField from "../FormFields/FloatingTextField.tsx";
import FloatingDateField from "../FormFields/FloatingDateField.tsx";
import Calendar from "../../assets/images/Calendar.svg";
import DuplicateorStopWarningModel from "../Popups/IdentityExists/index.jsx";
interface CitizenshipFormData {
  givenName: string;
  surname: string;
  dateOfBirth: string;
  citizenshipNumber: string;
  gender: string;
}

const Citizenship = ({ handleNext, handleBack }) => {
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors, isValid },
    reset,
  } = useForm<CitizenshipFormData>({
    shouldFocusError: true,
    mode: "onTouched",
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { appState, setAppState, userFlows, setUserFlows } =
    useContext(AppContext);
  const IVS_ADULT = "dee0075c-6dcd-ef11-b8e9-00224891c497"
  const IVS_CHILD = "fee0075c-6dcd-ef11-b8e9-00224891c497"
  const NZ_COUNTRY_ID = "18ebb77f-2341-e911-a85e-000d3ae0eb6e"

  const [showAgeModal, setShowAgeModal] = useState(false);
  const [pendingData, setPendingData] = useState({});

  const [duplicateData, setDuplicateData] = useState<any>(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  const surnameValue = watch("surname", "");
  const givenNameValue = watch("givenName", "");
  const [arsError, setArsError] = useState(false);
  // const dateOfBirthValue = watch("dateOfBirth", "");

  // eslint-disable-next-line no-control-regex
  const containsSpecialChars = /[^\x00-\x7F]/g.test(surnameValue);
  // eslint-disable-next-line no-control-regex
  const containsSpecialCharsGivenName = /[^\x00-\x7F]/g.test(givenNameValue);

  useEffect(() => {
    const applicant = appState?.requestPayload?.applicant;
    const event = appState?.requestPayload?.eventTypeSearch?.[0];

    if (applicant || event) {
      reset({
        givenName: event?.givenNames || applicant?.givenNames || "",
        surname: event?.familyName || applicant?.familyName || "",
        dateOfBirth: applicant?.dateOfBirth || "",
        citizenshipNumber:
          applicant?.citizenshipNumber || event?.documentNumber || "",
      });
    }
  }, [appState, reset]);

  // const calculateAge = (dob) => {
  //   const birth = new Date(dob);
  //   const now = new Date();
  //   let age = now.getFullYear() - birth.getFullYear();
  //   const m = now.getMonth() - birth.getMonth();
  //   if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
  //   return age;
  // };

  const onSubmit = (data) => {
    saveApplication(data, IVS_ADULT);
  };

  const saveApplication = async (
    data: CitizenshipFormData,
    applicationTypeId: string,
    byPassVerifyAge: boolean = false,
    byPassDuplicate: boolean = false
  ) => {
    setLoading(true);
    setArsError(false);
    console.log("Verifying ARS for data:", data);
    try {
      const vFormData = {
        arsId: data.citizenshipNumber,
        register: "citizenship",
        givenName: data.givenName,
        familyName: data.surname,
        dateOfBirth: data.dateOfBirth,

        countryOfBirthId: NZ_COUNTRY_ID,
      };
      const resp = await verifyArs(vFormData, navigate);
      console.log("ARS response:", resp);
      if (resp) {
        if (
          !resp.ok &&
          resp.error === "Maximum identity verification attempts exceeded."
        ) {
          console.error("Maximum identity verification attempts exceeded.");
          localStorage.removeItem("relayState");
          navigate("/app/attempts-exhausted");
          setLoading(false);
          return;
        }
        if (resp.error) {
          console.error("ARS verification failed:", resp);
          setArsError(true);
          setLoading(false);
          return;
        }
        console.log("ARS verification successful:", resp);

        // Check age for under 15
        if (!byPassVerifyAge && calculateAge(data.dateOfBirth) < 14) {
          setPendingData(data);
          setShowAgeModal(true);
          setLoading(false);
          setUserFlows({
            ...userFlows,
            showLiveness: false,
            childApplication: true,
          });

          return;
        }
        if (resp?.person?.stop) {
          // TODO: See how this should be handled (before same as duplicate)
          console.log("Stop found in ARS response");
          setPendingData(data);
          setDuplicateData(!!resp?.person?.duplicate);
          setShowDuplicateModal(true);
          setLoading(false);
          return;
        }
        if (resp?.person?.duplicate && !byPassDuplicate) {
          console.log("Duplicate found in ARS response");
          setPendingData(data);
          setDuplicateData(!!resp?.person?.duplicate);
          setShowDuplicateModal(true);
          setLoading(false);
          return;
        }
      }
      console.log("ARS verification successful:", resp.person.gender);

      const genderId = await getValueFromLabel(
        "GenderReference",
        resp.person.gender
      );
      console.log("Gender ID:", genderId);
      const countryOfBirthId = await getCountryByLabel(resp?.person?.country_of_birth || "New Zealand");
      const updatedAppState = {
        ...appState,
        requestPayload: {
          ...appState.requestPayload,
          applicationTypeId: applicationTypeId,
          applicationFlowCode: 100000000,
          applicant: {
            ...appState.requestPayload.applicant,
            givenNames: toTitleCase(data.givenName),
            familyName: toTitleCase(data.surname),
            dateOfBirth: data.dateOfBirth,
            citizenshipNumber: data.citizenshipNumber,
            placeOfBirth: toTitleCase(resp.person.place_of_birth?.trim() || "Unknown"),
            countryOfBirthId: countryOfBirthId?.dia_countryid || NZ_COUNTRY_ID,
            genderId: genderId,
            namesKnownAs: [
              {
                nameTypeId: "3ecbc107-c3b8-e911-a866-000d3ae10c61",
                familyName: toTitleCase(data.surname),
                givenNames: toTitleCase(data.givenName),
              },
            ],
          },
          eventTypeSearch: [
            {
              eventTypeId: "2dad80bb-5756-ed11-9562-002248941c78",
              documentNumber: data.citizenshipNumber,
              familyName: toTitleCase(data.surname || "").slice(0, 100),
              givenNames: toTitleCase(data.givenName || "").slice(0, 100),
              dateOfBirth: toTitleCase(data.dateOfBirth),
              placeOfBirth: toTitleCase(
                resp.person.place_of_birth || "Unknown"
              ),
              countryOfBirthId: countryOfBirthId?.dia_countryid || NZ_COUNTRY_ID,
              genderId: genderId,
            },
          ],
        },
      };
      // console.log("Updated Application State:", updatedAppState);
      if (updatedAppState.requestPayload.applicationId) {
        updateApplication(updatedAppState.requestPayload)
          .then((response) => {
            console.log("Application updated successfully:", response);
            setAppState(updatedAppState);
            handleNext();
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error updating application:", error);
            setLoading(false);
          });
      } else
        initiateApplication(updatedAppState.requestPayload)
          .then((response) => {
            console.log("Application initiated successfully:", response);
            updatedAppState.requestPayload.applicationId = response.serviceId;
            setAppState(updatedAppState);
            handleNext();
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error initiating application:", error);
            setLoading(false);
          });
    } catch (error) {
      console.error("Error verifying ARS:", error);
      setLoading(false);
      setArsError(true);

      return;
    }
  };

  const handleAgeModalContinue = () => {
    setShowAgeModal(false);
    // Double-check age as pendingData is set also for duplicate/stop
    if (pendingData && calculateAge(pendingData.dateOfBirth) < 14) {
      saveApplication(
        pendingData,
        IVS_CHILD,
        true
      );
    }
  };

  const handleDuplicateModalContinue = () => {
    setShowDuplicateModal(false)
    if (pendingData) {
      if (calculateAge(pendingData.dateOfBirth) < 14) {
        // If child, agemodal was displayed before and continued, so bypass it.
        saveApplication(
          pendingData,
          IVS_CHILD,
          true,
          true
        );
      } else {
        saveApplication(
          pendingData,
          IVS_ADULT,
          false,
          true
        );
      }
    }
  };

  const handleAgeModalCancel = () => {
    redirectToRealMe();
  };

  const onClose = () => {
    setShowAgeModal(false);
  };
  const handleModalCancel = () => {
    redirectToRealMe();
  };

  return (
    <>
      {showAgeModal && (
        <AgeWarningModal
          onContinue={handleAgeModalContinue}
          onCancel={handleAgeModalCancel}
          onClose={onClose}
        />
      )}

      {loading && <Loader />}
      {showDuplicateModal && (
        <DuplicateorStopWarningModel
          onContinue={handleDuplicateModalContinue}
          onCancel={handleModalCancel}
          onClose={onClose}
          showDuplicate={duplicateData}
        />
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Kōrero mai ko wai koe
          </h1>
          <hr />
          <h1 className="intro-title">Tell us who you are</h1>

          <div className="step-container">
            <h2 className="step-title mb-2">
              Your New Zealand citizenship details
            </h2>
            <p className="mb-4">
              Enter your details exactly as they appear on your citizenship
              certificate.
            </p>

            <FloatingTextField
              name="givenName"
              label="Given name(s)"
              inputProps={register("givenName", {
                validate: (value) => {
                  console.log("Validate called for givenName:", value);
                  return (
                    !value ||
                    value?.trim().length < 198 ||
                    "Given name(s) must be less than 198 characters."
                  );
                },
              })}
              error={errors.givenName}
            />
            <p className="note">
              If you have one name, enter it as your surname or family name.
            </p>
            <FloatingTextField
              name="surname"
              label="Surname or family name"
              required
              inputProps={register("surname", {
                required: "This field is required",
                maxLength: {
                  value: 84,
                  message: "Family name must be less than 85 characters.",
                },
              })}
              error={errors.surname}
            />

            {(containsSpecialChars || containsSpecialCharsGivenName) && (
              <FieldError
                error={null}
                info="Your name contains a special character (such as an umlaut, cedilla, accent, or macron). When your name is recorded by other organisations that use RealMe, it may appear differently."
              />
            )}

            <FloatingTextField
              name="citizenshipNumber"
              label="Citizenship certificate number"
              required
              inputProps={register("citizenshipNumber", {
                required: "This field is required",
              })}
              error={errors.citizenshipNumber}
            />

            <FloatingDateField
              name="dateOfBirth"
              label="Date of birth (dd/mm/yyyy)"
              control={control}
              calendarIcon={Calendar}
              required
              error={errors.dateOfBirth}
            />
            {arsError && (
              <FieldError
                info={null}
                error={{
                  message:
                    "We could not verify your citizenship details. Please check your details and try again.",
                }}
              />
            )}
          </div>
        </div>

        <div className="step-button-container">
          <SubmitButton
            onClick={() => {}}
            text={"Save and continue"}
            type="submit"
            disabled={!isValid}
          />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default Citizenship;
